<div class="center-xy" [ngStyle]="{ overflow: zones.overflow ? 'auto' : 'hidden'}"
    data-testid="zone-system-card"
    *ngIf="zones.selectedContainer">
    <div class="zone-control-wrapper bg-light">
        <div class="zone-control__top">
            <div class="zone-control__top-icon bg-style bg-style__icon border-light">
                <div *ngIf="zones.selectedContainer.iconId !== 0">
                    <img ngSrc="/assets/img/id_icons/{{ zones.selectedContainer.iconId }}.svg"
                         width="68" height="68" alt="" />
                </div>
                <icon [iconName]="'settings'"
                      [iconSize]="68"
                      [className]="'zone-control__top-custom-icon'"
                      *ngIf="zones.selectedContainer.iconId === 0">
                </icon>
            </div>
            <p class="zone-control__top-name font-bold font-24 bg-style bg-style__label color-light">
                {{ zones.selectedContainer.containerName }}
            </p>
        </div>

        <div class="zone-control__content">
            <div class="zone-control__buttons-top">
                <div class="zone-control__close-button cursor-pointer bg-cancel bg-cancel__button"
                    data-testid="close-control"
                    (click)="zones.goBack()">
                    <img ngSrc="/assets/img/zone_icons/back_without_border.svg"
                         width="40" height="40" alt="" />
                </div>
            </div>
            <div class="dropdown-list dropdown-list--info">
                <div class="dropdown-list__item font-12 font-bold">
                    <p class="dropdown-list__item-name">
                        {{ subtitle(8309) }}
                    </p>
                    <div class="dropdown-list__value dropdown-list__value--single">
                        <img class="dropdown-list__signal dropdown-list__signal--no-margin"
                             data-testid="parameter-communication-icon"
                             *ngIf="zones.selectedContainer.parameters.signal >= 0
                                || zones.selectedContainer.parameters.signal === -2"
                             ngSrc="{{zones.signalIcon({
                                signalStrength: zones.selectedContainer.parameters.signal
                                })}}"
                             width="19" height="19" alt="" />
                        <div *ngIf="zones.selectedContainer.parameters.signal === -3"
                             class="dropdown-list__value dropdown-list__value--wide color-alarm">
                            <div>{{ subtitle(4282) }}</div>
                            <div class="dropdown-list__value--single">
                                {{ subtitle(1808) }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="dropdown-list__item font-12 font-bold">
                    <p class="dropdown-list__item-name">
                        {{ subtitle(12740) }}
                    </p>
                    <div class="dropdown-list__value dropdown-list__value--single">
                        <p class="dropdown-list__value-name">
                            {{ subtitle(zones.selectedContainer.parameters.ecoInputState ? 5829 : 5830) }}
                        </p>
                    </div>
                </div>
                <div class="dropdown-list__item font-12 font-bold">
                    <p class="dropdown-list__item-name">
                        {{ subtitle(814) }}
                    </p>
                    <div class="dropdown-list__value dropdown-list__value--single">
                        <p class="dropdown-list__value-name">
                            {{ subtitle(zones.selectedContainer.parameters.hcState ? 1816 : 1815) }}
                        </p>
                    </div>
                </div>
                <div class="dropdown-list__item font-12 font-bold">
                    <p class="dropdown-list__item-name">
                        {{ subtitle(3089) }}
                    </p>
                    <div class="dropdown-list__value dropdown-list__value--single">
                        <p class="dropdown-list__value-name">
                            {{ subtitle(zones.selectedContainer.parameters.pumpsState ? 2792 : 2618) }}
                        </p>
                    </div>
                </div>
                <div class="dropdown-list__item font-12 font-bold">
                    <p class="dropdown-list__item-name">
                        {{ subtitle(1736) }}
                    </p>
                    <div class="dropdown-list__value dropdown-list__value--single">
                        <p class="dropdown-list__value-name">
                            {{ subtitle(zones.selectedContainer.parameters.freeContactState ?  5829 : 5830) }}
                        </p>
                    </div>
                </div>
                <div class="dropdown-list__item font-12 font-bold">
                    <p class="dropdown-list__item-name">
                        {{ subtitle(1634) }}
                    </p>
                    <div class="dropdown-list__value dropdown-list__value--single">
                        <p class="dropdown-list__value-name">
                            {{ zones.selectedContainer.version }}
                        </p>
                    </div>
                </div>
                <div class="dropdown-list__item font-12 font-bold">
                    <p class="dropdown-list__item-name">
                        {{ subtitle(8490) }}
                    </p>
                    <div class="dropdown-list__value dropdown-list__value--single">
                        <p class="dropdown-list__value-name">
                            {{ zones.selectedContainer.processorId }}
                        </p>
                    </div>
                </div>
                <div class="dropdown-list__item dropdown-list__item--higher dropdown-list__item--table font-12 font-bold">
                    <ng-container
                        *ngFor="let connection of zones.selectedContainer.connections; let idx = index">
                        <connection-table
                            [container]="{
                                containerId: zones.selectedContainer.containerId,
                                data: zones.selectedContainer
                            }"
                            [chunk]="idx"
                        ></connection-table>
                    </ng-container>
                </div>
                <div class="dropdown-list__item dropdown-list__item--higher font-12 font-bold"
                    *ngIf="zones.selectedContainer.wikiId !== 0">
                    <p class="dropdown-list__item-name">
                        {{ subtitle(1107) }}
                    </p>
                    <div class="dropdown-list__value dropdown-list__value--single">
                        <p class="dropdown-list__value-name">
                            {{ subtitle(zones.selectedContainer.wikiId) }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
